'use strict';

import { delegate, getAttributes } from 'dom-utils';
import $ from 'jquery';

class Tracking {

    constructor() {

        this.opts = {
            events: ['click', 'change', 'keyup'],
            attributePrefix: 'data-gtm-',
            eventName: 'eventTrack'
        };

        this.init();
    }

    init() {

        this.handleEvents = this.handleEvents.bind(this);
        this.send = this.send.bind(this);

        const selector = `[${this.opts.attributePrefix}on]`;

        let $mailLinks = $('a[href^="mailto"]');
        let $externalLinks = $('a').filter(function () {
          return this.hostname &&
            !this.href.match(/^mailto\:/) &&
            this.hostname !== location.hostname &&
            !this.hasAttribute('data-gtm-on');
        });

        this.delegates = {};

        this.opts.events.forEach(event => {
            this.delegates[event] = delegate(document, event, selector, this.handleEvents, {
                composed: true,
                useCapture: true
            });
        });

        // <button
        // data-gtm-on="click"
        // data-gtm-event-category="category"
        // data-gtm-event-action="action"
        // data-gtm-event-label="label">
        //btn </button>


        $(window).on('gtm:send', this.send); // $(window).trigger('gtm:send', [ 'category', 'action', 'label']);
        $mailLinks.on('click', this.onClickMailto.bind(this));
        $externalLinks.on('click', this.onExternalLinkClick.bind(this))
    }

    static camelCase(str) {
        return str.replace(/[\-\_]+(\w?)/g, function (match, p1) {
            return p1.toUpperCase();
        });
    }

    getAttributeFields(element, prefix) {
        const attributes = getAttributes(element);
        const attributeFields = {};

        Object.keys(attributes).forEach(attribute => {
            if (attribute.indexOf(prefix) === 0 && attribute !== prefix + 'on') {
                let value = attributes[attribute];
                if (value === 'true') value = true;
                if (value === 'false') value = false;
                const field = this.constructor.camelCase(attribute.slice(prefix.length));
                attributeFields[field] = value;
            }
        });

        return attributeFields;
    }

    handleEvents(event, element) {

        if (typeof dataLayer === 'undefined') return;

        const prefix = this.opts.attributePrefix;
        const events = element.getAttribute(prefix + 'on').split(/\s*,\s*/);

        if (events.indexOf(event.type) < 0) return;

        const attributeFields = this.getAttributeFields(element, prefix);

        attributeFields.event = this.opts.eventName;

        dataLayer.push(attributeFields);


    }

    send() {

        if (typeof dataLayer === 'undefined') return;

        let [e, category, action, label] = [...arguments];

        dataLayer.push(Object.assign({},
            {'event': this.opts.eventName},
            category && {'eventCategory': category},
            action && {'eventAction': action},
            label && {'eventLabel': label}

        ));

    }

    onClickMailto(e) {
        let $link = $(e.target).closest('a');
        let email = $link.attr('href').substr(7);
        $(window).trigger('gtm:send', [ 'Email', 'Click', email])
    }

    onExternalLinkClick(e) {
        let linkDestination = $(e.target).closest('a').attr('href');
        $(window).trigger('gtm:send', [ 'Link', 'Click', window.location.href + ' > ' + linkDestination])
    }

}

let tracking = new Tracking();



// WEBPACK FOOTER //
// ./components/tracking/scripts/tracking.js